import React, { FC, useEffect, useState } from "react";
import "./index.scss";
import DayPicker, { DateUtils } from 'react-day-picker';
import DayPickerNavbar from '../DayPickerNavbar';
import Weekday from '../../menus/Timeline2/DayPickerCustomWeekday';

type RangeDayPickerProps = {
    defaultRange: {
        startDate: Date,
        endDate: Date
    }
    onRangeChange?: (range: {from: Date | undefined, to: Date | undefined}) => void
}

const RangeDayPicker: FC<RangeDayPickerProps> = ({defaultRange, onRangeChange}) => {
    const [range, setRange] = useState({from: defaultRange?.startDate, to: defaultRange?.endDate});
    const modifiers = { start: range.from, end: range.to };
    const visibleMonth = range.from || range.to || defaultRange?.startDate || defaultRange?.endDate || new Date();
    const handleDayClick = (day) => {
        const newRange = DateUtils.addDayToRange(day, range);
        setRange(newRange);
    }

    const defaultFromTs = defaultRange?.startDate?.getTime();
    const defaultToTs = defaultRange?.endDate?.getTime();

    useEffect(() => {
        const currentFromTs = range.from?.getTime();
        const currentToTs = range.to?.getTime();

        if (currentFromTs === defaultFromTs && currentToTs === defaultToTs) {
            return;
        }

        setRange({
            from: defaultRange?.startDate,
            to: defaultRange?.endDate,
        });
    }, [defaultFromTs, defaultToTs]);

    useEffect(() => {
        onRangeChange?.(range);
    }, [range]);

    const today = new Date();
    return (
        <DayPicker
            className="day-picker"
            month={visibleMonth}
            selectedDays={[range.from, range]}
            modifiers={modifiers}
            onDayClick={handleDayClick}
            weekdayElement={Weekday}
            navbarElement={DayPickerNavbar}
            captionElement={() => null}
            disabledDays={{after: today}}
            showOutsideDays={true}
        />
    )
}

export default RangeDayPicker;